/*
 * Contador de ofertas de Colchones Fantasía (snippets/fantasia-contador.liquid).
 * Cada contador trae la hora de fin en segundos (data-fantasia-contador). Se actualiza cada
 * segundo, incluso en tarjetas que llegan después (filtros, «cargar más»), y se oculta cuando
 * la oferta termina.
 */
(() => {
  const dos = (n) => String(n).padStart(2, '0');
  const parte = (valor, unidad) => `<span class="fantasia-contador__num">${valor}<small>${unidad}</small></span>`;

  const pintar = () => {
    const ahora = Date.now();
    document.querySelectorAll('[data-fantasia-contador]').forEach((el) => {
      const fin = Number(el.dataset.fantasiaContador) * 1000;
      const resta = Math.floor((fin - ahora) / 1000);

      if (!fin || resta <= 0) {
        el.hidden = true;
        return;
      }

      const d = Math.floor(resta / 86400);
      const h = Math.floor((resta % 86400) / 3600);
      const m = Math.floor((resta % 3600) / 60);
      const s = resta % 60;
      const tiempo = el.querySelector('.fantasia-contador__tiempo');
      const texto = (d > 0 ? parte(d, 'd') : '') + parte(dos(h), 'h') + parte(dos(m), 'm') + parte(dos(s), 's');

      if (tiempo.innerHTML !== texto) tiempo.innerHTML = texto;
      el.classList.toggle('fantasia-contador--ultimo-dia', d === 0);
      el.setAttribute('aria-label', `${el.querySelector('.fantasia-contador__texto').textContent} ${d ? d + ' días, ' : ''}${h} horas y ${m} minutos`);
      el.hidden = false;
    });
  };

  pintar();
  setInterval(pintar, 1000);
})();
